<script>
import Base from '@/plans/ZOOM_CLIPS/config/base';

export default {
  name: "ZoomClipsPlusBuyNow",
  extends: Base,
  computed: {
    canRmv() {
      return this.$context.type !== this.planType;
    },
  },
};
</script>
